import React from "react";  
import ForgotPasswordForm from "../../components/Auth/ForgotPasswordForm";

const ForgotPassword = () => {
  return (
    <>
      <ForgotPasswordForm />
    </>
  );
};

export default ForgotPassword;
